import { useState } from "react";
import { ViewProgressSummaryInnerCard } from "components/molecules/ViewProgressSummaryInnerCard";
import { decodeToken } from "utils/functions/decodeToken";
import classNames from "classnames";
import "./index.scss";

interface IProps {
  btnLabel: string;
  cardLabel: string;
  secondaryBtnLabel: string;
  secondaryCardLabel: string;
  thirdBtnLabel: string;
  thirdCardLabel: string;
  onClick: (cardType: string) => void;
}

export const ViewProgressSummaryInnerCardGroup = ({
  btnLabel,
  cardLabel,
  secondaryBtnLabel,
  secondaryCardLabel,
  thirdBtnLabel,
  thirdCardLabel,
  onClick,
}: IProps) => {
  const payload = decodeToken();
  const [isShowStudyRecommendation] = useState(
    payload &&
    payload.hasOwnProperty("showstudyrecommendations") &&
    payload.showstudyrecommendations.toLowerCase() === "true"
  );
  const [isShowOverallProgressSummary] = useState(
    payload &&
    payload.hasOwnProperty("showoverallprogresssummary") &&
    payload.showoverallprogresssummary.toLowerCase() === "true"
  );
  const [isShowPerformanceSummary] = useState(
    payload &&
    payload.hasOwnProperty("showperformancesummary") &&
    payload.showperformancesummary.toLowerCase() === "true"
  );

  return (
    <div
      className={classNames({
        "view-progress-card-inner-card-wrapper": true,
        "is-hide-ai-nav-card": !isShowStudyRecommendation,
        "is-hide-progress-summary-nav-card": !isShowOverallProgressSummary,
        "is-hide-performance-summary-nav-card": !isShowPerformanceSummary,
      })}
    >
      {isShowOverallProgressSummary && isShowPerformanceSummary && isShowStudyRecommendation ?
        <>
          <ViewProgressSummaryInnerCard
            btnLabel={btnLabel}
            cardLabel={cardLabel}
            onClick={onClick}
          />
          <ViewProgressSummaryInnerCard
            btnLabel={secondaryBtnLabel}
            cardLabel={secondaryCardLabel}
            onClick={onClick}
          />
        </>
        : isShowOverallProgressSummary && isShowPerformanceSummary ?
          <ViewProgressSummaryInnerCard
            btnLabel={btnLabel}
            cardLabel={cardLabel}
            onClick={onClick}
          /> : isShowPerformanceSummary && isShowStudyRecommendation ?
            <ViewProgressSummaryInnerCard
              btnLabel={secondaryBtnLabel}
              cardLabel={secondaryCardLabel}
              onClick={onClick}
            /> : isShowOverallProgressSummary && isShowStudyRecommendation ?
              <ViewProgressSummaryInnerCard
                btnLabel={thirdBtnLabel}
                cardLabel={thirdCardLabel}
                onClick={onClick}
              /> : null
      }
    </div>
  );
};
